<template>
  <div>
      <v-row>
        <p>Dados Técnicos do serviço</p>
      </v-row>
      
      <v-row>

       <v-col cols="12" md="3">
         <v-textarea v-model = "formula"
           label="Fórmula" >
         </v-textarea>
        <v-btn @click = "validate">
          Validar
        </v-btn>
      </v-col>

      </v-row>


    
  </div>
</template>



<script>
import SolarPlant from "../../../../../src/libraries/classes/SolarPlant"
//import SolarFunctions from "@/libraries/classes/SolarFunctions.js";

export default {
  components: {
  },

  name: "edit-service",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      formula:"a + b",
      selected: [],
      solarPlant:{},
  


      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },

                messages : [],
          inverters : [],
          acVoltage : 220,
          acPower : 0,
          phases : 3,
          nInverters : 0,
          nModules : 0,
          modules : [],
          mppts : [],
          nMax : 0,
          dcPower : 0,
          dcMaxPower : 0,
          dcMinPower : 0,
          config : [],
          nMin : 0,
          city : {},
          efficiency : 77,//percentage
          production : {
              average: 0,
              months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29]
          },
          structure : {},
          accessories : [],
          stringboxes : [],
          cables : [],
          connectors : [],
          rails : [],
          transformers: [],
          mountings:[
              //  { mountingId:"xx",  module:{},quantity:10, type:"", orientation:"portrait", azimuth:"degrees 0:north" , tilt :"degrees 0 : horizontal" , height:"xx m" , area:"xx m2"},
          ],

          varKeys:[
              {key:"[Potência DC]", variable: "this.dcPower"},
              {key:"[Quantidade de módulos]", variable: "this.nModulos"},
              //{key:"[Potência DC]", variable: "this.dcPower"},
              //{key:"[Potência DC]", variable: "this.dcPower"},


          ],

    };
  },
  created(){
    
  },

  methods: {
    validate(){
      var f = this.formula;
      var a = 1;
      var b= 2;

      var x;
      // var solarPlant = {
      //     messages : [],
      //     inverters : [],
      //     acVoltage : 220,
      //     acPower : 0,
      //     phases : 3,
      //     nInverters : 0,
      //     nModules : 0,
      //     modules : [],
      //     mppts : [],
      //     nMax : 0,
      //     dcPower : 0,
      //     dcMaxPower : 0,
      //     dcMinPower : 0,
      //     config : [],
      //     nMin : 0,
      //     city : {},
      //     efficiency : 77,//percentage
      //     production : {
      //         average: 0,
      //         months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //         years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29]
      //     },
      //     structure : {},
      //     accessories : [],
      //     stringboxes : [],
      //     cables : [],
      //     connectors : [],
      //     rails : [],
      //     transformers: [],
      //     mountings:[
      //         //  { mountingId:"xx",  module:{},quantity:10, type:"", orientation:"portrait", azimuth:"degrees 0:north" , tilt :"degrees 0 : horizontal" , height:"xx m" , area:"xx m2"},
      //     ],
      // }

      //var solarPlant = new SolarPlant();
  

      try {
          x =  eval(f); 
        } catch (e) {
          alert(e)
            if (e instanceof SyntaxError) {
                alert(e);
            }
        }

    //  alert(x)
    }
    
  },
};
</script>
